module.exports = __webpack_public_path__ + "static/media/_Dashboard Sidebar Item Master (3).dd69cf37.svg";